import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DescriptionPage.css'; // Можно использовать общие стили для страниц описания

function ExperimentIntroPage() {
  const navigate = useNavigate();

  return (
    <div className="page-container description-page">

<h1>Вам будет представлена серия коротких видеороликов, в которых люди со скрытыми лицами будут переживать различные эмоции</h1>
 <p>Всего представлены 2 варианта тестирования:</p>
 <p><strong>Тест 1:</strong> распознавание эмоций при просмотре видеороликов без звука.</p>
 <p><strong>Тест 2:</strong> распознавание эмоций при просмотре видеороликов со звуком.</p>
 <p>После каждого видео будет представлено «Колесо эмоций» - 14 слов, обозначающих эмоции, которые помогут вам быстро выбрать соответствующую эмоцию. Данное «Колесо эмоций» показано ниже:</p>
      <div className="image-container">
        <img
          src={`${process.env.PUBLIC_URL}/emotion_wheel.png`}
          alt="Колесо эмоций"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
     <div className="navigation-buttons">
          <button onClick={() => navigate('/training-intro')}>Начать тренировку</button>
          <button onClick={() => navigate('/emotion-list')}>Пояснение списка эмоций</button>
        </div>
      </div>
    );
  }

export default ExperimentIntroPage;